/**************************************************
 * Nombre:       Home_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Tarjeta_Contacto from "../../Tarjetas/Tarjeta_Contacto";
import {Constantes} from "../../../Constantes";
import {Map, WhatsApp} from '@mui/icons-material'
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Contactos = () => {
    const {sCell,masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        direction={'row-reverse'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    color: '#fff',
                                    px: !masSM ? 4 : 6,
                                    py: !masSM ? 6 : 12,
                                    borderRadius: 6,
                                    borderTopRightRadius: sCell ? 24 : 128
                                }}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontSize: !masSM ? 32 : 48,
                                            fontWeight: 800,
                                            fontFamily: 'Raleway',
                                            lineHeight: 1.1
                                        }}>
                                        Estamos Aquí Para Escucharte y Acompañarte
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mb: 2, mt: 2}}>
                                    <Typography
                                        sx={{fontSize: 16, fontWeight: 300, fontFamily: 'Roboto', color: '#C4C4C4'}}>
                                        Queremos estar cerca de ti en cada momento. Contáctanos y recibe la atención
                                        cálida y personalizada que mereces.
                                    </Typography>
                                </Grid>


                                {Constantes.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Tarjeta_Contacto item={it}/>
                                        </Grid>
                                    )
                                })}

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 6}}>
                                    <Grid
                                        container
                                        justifyContent={!masSM ? 'center' : 'space-between'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        <Button
                                            onClick={() => iniciarChatWass({mensaje: 'Hola Magaza'})}
                                            endIcon={<WhatsApp/>}
                                        >
                                            Chat WhatsApp
                                        </Button>

                                        <Button
                                            endIcon={<Map/>}
                                            sx={{mt: !masSM ? 4 : 0}}
                                        >
                                            Guiame
                                        </Button>

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22768.37737780116!2d-78.90041439197171!3d0.015315009822733823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e2a9dbb5bd32745%3A0x5c4327c3869cde0d!2sSan%20Miguel%20de%20Los%20Bancos%2C%20Ecuador!5e0!3m2!1ses-419!2sco!4v1757974289187!5m2!1ses-419!2sco"
                                width="100%" height={sCell ? 350 :"550"} allowFullScreen="" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                style={{
                                    border: 0,
                                    borderBottomLeftRadius: 20,
                                    borderTopLeftRadius: 20,
                                    borderTopRightRadius: sCell ? 20 : 0,
                                    borderBottomRightRadius: sCell ? 20 : 0
                                }}
                            ></iframe>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Contactos